import React, { useState, useEffect } from "react";
import { useRouteMatch, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { withRouter } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { ERROR_MESSAGE } from "../../constants";
import ModalConfirm from "../../utils/form/modalConfirmBase";
import Favorites from "../../componentes/userConfiguration/favorites";
import Drag from "../../componentes/userConfiguration/favorites/dragDrop";
import Test from "../../componentes/userConfiguration/favorites/test";
import { useStateValue } from "../../context/store";
import { updateFavorite } from "../../actions/user-config-actions";
import { useRoles } from "../../componentes/userConfiguration/favorites/roles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
}));

const UserConfiguration = (props) => {
  const [{ breadCrumb, sessionUser }, dispatch] = useStateValue();
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });

  const { userId } = useRoles();
  const [favorites, setFavorites] = useState([]);

  const [hasDragChanges, setHasDragChanges] = useState(false);

  const [confirm, setConfirm] = useState(false);

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const updateFavoriteDragAsync = async () => {
    let moduleList = [];
    if (favorites) {
      moduleList = favorites.map((fav, index) => {
        return {
          moduleId: fav.roleId,
          order: index + 1,
        };
      });
    }

    var body = {
      userId,
      moduleList,
    };

    const saveResponse = await updateFavorite(body, dispatch);
    if (
      saveResponse &&
      saveResponse.status >= 200 &&
      saveResponse.status < 399
    ) {
      setMessage(() => ({
        open: true,
        question: `Atajos actualizados correctamente`,
        type: "SUCCESS",
        handleClick: closeMessage,
        oneButtons: true,
      }));
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: saveResponse?.data?.detail
            ? saveResponse?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  };

  const saveUserConfigChanges = () => {
    if (hasDragChanges) {
      updateFavoriteDragAsync();
    }
  };

  useEffect(() => {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configuración de la cuenta",
      breadCrumbSubText: "Configuración de la cuenta",
      index: 15,
      isUserConfig: true,
      handleCancelUserConfig: false,
      handleSaveUserConfig: false,
    });
  }, []);

  if (breadCrumb?.handleSaveUserConfig) {
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Configuración de la cuenta",
      breadCrumbSubText: "Configuración de la cuenta",
      index: 15,
      isUserConfig: true,
      handleCancelUserConfig: false,
      handleSaveUserConfig: false,
    });
    setTimeout(() => {
      saveUserConfigChanges();
    }, 100);
  }

  const onSave = (favorites) => {};

  const classes = useStyles();
  return (
    <div style={{ marginTop: "25px" }}>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            test
            <Test/>
            <Paper className={classes.paper}>xs=8</Paper>
          </Grid>
          <Grid item xs={4}>
            test
            <Paper className={classes.paper}>xs=4</Paper>
          </Grid>
          <Grid item xs={6}>
            <Drag
              setFavorites={setFavorites}
              setHasDragChanges={setHasDragChanges}
            />
          </Grid>
          <Grid item xs={6}></Grid>
        </Grid>
        <ModalConfirm
          description={message.description}
          textButtonSubmit={message.textButtonSubmit}
          handleClick={message.handleClick}
          handleClickOut={message.handleClickOut}
          oneButtons={message.oneButtons}
          type={message.type}
          open={message.open}
        />
      </div>
    </div>
  );
};

export default withRouter(UserConfiguration);
